
(function () {
  const oldText = "Your order is protected for ";
  const newText = "Your order can be protected for ";

  function updateRouteText() {
    const elements = document.querySelectorAll(
      '[id^="pw-coverage-description"]'
    );

    elements.forEach((element) => {
      const walker = document.createTreeWalker(
        element,
        NodeFilter.SHOW_TEXT
      );

      let node;

      while ((node = walker.nextNode())) {
        if (node.nodeValue.includes(oldText)) {
          node.nodeValue = node.nodeValue.replace(
            oldText,
            newText
          );
        }
      }
    });
  }

  // Update existing Route text
  updateRouteText();

  // Handle Route widget updates and cart changes
  const observer = new MutationObserver(updateRouteText);

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();
